module.exports = __webpack_public_path__ + "static/media/down_expand_white.65c8e6a2.svg";